let subcardFilterTimeout: any;

function filterTable($table: JQuery<HTMLTableElement>, term: string, clear?: boolean) {
  const reset = clear || !term;
  const $tbody = $table.find('tbody');
  const $trs = $tbody.find('tr:not(.quick-filter-no-result)');
  const $noResultsTr = $tbody.find('.quick-filter-no-result');
  const termNormalized = window.DexeroCoreApp.normalizeText(term);
  const $clearButton = $table.find('.subcard-quick-filter-clear');

  if (term) {
    $clearButton.removeClass('hide');
  } else {
    $clearButton.addClass('hide');
  }

  if (reset) {
    $trs.removeClass('hide');
    $noResultsTr.addClass('hide');
    return;
  }

  $trs.addClass('hide');
  $noResultsTr.addClass('hide');
  const $matchedTrs = $trs.filter((_, tr) => {
    const $tr = $(tr);
    const $tds = $tr.find('td:not(.index):not(.actions)');
    const text = $tds
      .map((__, td) => {
        const $td = $(td);
        const $span = $td.find('span.static');
        const innerText = $span.length ? $span.text().trim() : $td.text().trim();
        return innerText;
      })
      .get()
      .join(' ');
    const textNormalized = window.DexeroCoreApp.normalizeText(text);
    return textNormalized.indexOf(termNormalized) !== -1;
  });

  $matchedTrs.removeClass('hide');
  if ($matchedTrs.length === 0) {
    $noResultsTr.removeClass('hide');
  }
}

function handleItemsQuickFilterKeydown(e: JQuery.KeyDownEvent) {
  const key = e.which || e.charCode || e.keyCode;
  if (key === 13) {
    // Enter Key
    e.preventDefault();
  }
  clearTimeout(subcardFilterTimeout);

  subcardFilterTimeout = setTimeout(() => {
    const $elm = $(e.currentTarget);
    const value = $elm.val() as string;
    const $table = ($elm as any).closest('table') as JQuery<HTMLTableElement>;
    filterTable($table, value);
  }, 350);
}

function subcardQuickFilterClear(e: JQuery.ClickEvent<HTMLElement>) {
  const $elm = $(e.currentTarget);
  const $table = ($elm as any).closest('table') as JQuery<HTMLTableElement>;
  const $itemsQuickFilter = $table.find('.items-quick-filter');
  $itemsQuickFilter.val('');
  filterTable($table, '', true);
}

export default function subformQuickFilterBindings() {
  $('body')
    .off('keydown', '.fieldSubForm .items-quick-filter')
    .on('keydown', '.fieldSubForm .items-quick-filter', handleItemsQuickFilterKeydown)
    .off('click', '.fieldSubForm .subcard-quick-filter-clear')
    .on('click', '.fieldSubForm .subcard-quick-filter-clear', subcardQuickFilterClear);
}
